<template>
  <div v-loading.fullscreen="loading">
    <div v-if="!loading">
      <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'userList' }">Users</el-breadcrumb-item>
        <el-breadcrumb-item>New</el-breadcrumb-item>
      </el-breadcrumb>

      <h2 class="page-title">New Users</h2>

      <el-form
        ref="form"
        :rules="rules"
        :model="model"
        :label-position="labelPosition"
        :label-width="labelWidth"
        @submit.native.prevent="save"
      >
        <div class="block">
          <el-form-item label="Emails" prop="emails">
            <el-col :lg="11" :md="16" :sm="24">
              <el-select
                v-model="model.emails"
                default-first-option
                multiple
                filterable
                allow-create
                placeholder="Emails"
                no-data-text="Please inform the email and press enter"
              ></el-select>
            </el-col>
          </el-form-item>

          <el-form-item label="Roles" prop="roles">
            <el-col :lg="11" :md="16" :sm="24">
              <el-select multiple v-model="model.roles" filterable placeholder="Roles">
                <template v-if="roles">
                  <el-option
                    v-for="option in roles"
                    :key="option.id"
                    :label="option.label"
                    :value="option.id"
                  />
                </template>
              </el-select>
            </el-col>
          </el-form-item>
        </div>

        <div class="button-group mt-3">
          <el-button
            @click="save()"
            :disabled="loading"
            type="primary"
            icon="el-icon-fa-floppy-o"
          >Save</el-button>
          <el-button @click="back()" :disabled="loading" icon="el-icon-fa-times">Cancel</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Roles from "@/auth/roles";

const emailsValidator = () => {
  const requiredFn = (rule, value, callback) => {
    if (!value || !value.length) {
      callback(new Error("Must select at least one email"));
      return;
    }

    callback();
  };

  const emailFn = (rule, value, callback) => {
    if (!value || !value.length) {
      callback();
      return;
    }

    const isEmailValid = email => {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    };

    // eslint-disable-next-line
    for (const email of value) {
      if (!isEmailValid(email)) {
        callback(new Error(`Email ${email} is invalid`));
        return;
      }
    }

    callback();
  };

  const output = [];

  output.push({
    type: "array",
    required: true,
    validator: requiredFn
  });

  output.push({
    type: "array",
    validator: emailFn
  });

  return output;
};

const rolesValidator = () => {
  const requiredFn = (rule, value, callback) => {
    if (!value || !value.length) {
      callback(new Error("Must select at least one role"));
      return;
    }

    callback();
  };

  const output = [];

  output.push({
    type: "array",
    required: true,
    validator: requiredFn
  });

  return output;
};

export default {
  name: "app-user-new",

  props: {
    id: String,
    previous: String
  },

  data() {
    return {
      rules: {
        emails: emailsValidator(),
        roles: rolesValidator()
      }
    };
  },

  created() {
    this.$store.dispatch("user/new");
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("user/clear");
    next();
  },

  computed: {
    ...mapGetters({
      model: "user/model",
      loading: "user/loading",
      labelPosition: "shared/labelPosition",
      labelWidth: "shared/labelWidth"
    }),

    editing: state => !!state.id,

    roles() {
      return Roles.asArray;
    }
  },

  methods: {
    save() {
      this.$refs.form.validate().then(valid => {
        if (!valid) {
          return;
        }

        this.$store.dispatch("user/create").then(() => {
          this.back();
        });
      });
    },

    back() {
      if (this.previous === "show") {
        this.$router.push({
          name: "userShow",
          params: { id: this.id }
        });
        return;
      }

      this.$router.push({ name: "userList" });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/user/user-new.vue?88353c08